import { ApiRequest } from '../../api/request';

export class SecuritiesService extends ApiRequest {
  constructor($http, $q) {
    'ngInject';
    super({ $http, $q });
  }

  loginAndFetch(resource, credentials) {
    return this.$http({
      method: 'POST',
      data: {
        bankCode: resource.identifier,
        username: credentials[0],
        password: credentials[1]
      },
      url: '/api/securities'
    });
  }

  loginWithUBA() {
    return this.$http.get('/api/uba/login');
  }

  fetchWithUBA(userIdentifier) {
    return this.$http({
      method: 'POST',
      data: {
        userIdentifier
      },
      url: '/api/uba/transactions'
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/data/source/securitiesSource.js